import React from "react";
import Circle from "../img/circle.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import works from "../data/works";
import { Link } from "react-router-dom";

function WorksSection() {
  return (
    <section id="projects">
      <div className="container">
        <div className="col-lg-6">
          <div className="about-text text-left">
            <h4 className="services-spantext">Works</h4>
            <img
              className="about-image"
              src={Circle}
              alt="images"
              className="circle1"
            />
            <h1 className="title-font">Featured Projects</h1>
            <div className="projectbtncontainer">
              <Link to="/works">
                <button className="btn projectbutton">
                  Explore Projects &nbsp; &nbsp;
                  <FontAwesomeIcon
                    icon={faArrowRight}
                    className="bodybutton-icon"
                  />
                </button>
              </Link>
            </div>
          </div>
        </div>
        <div className="scrolling-wrapper">
          {works.map((works) => (
            <img
              className="projectimage"
              src={works.src}
              alt="project images"
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default WorksSection;
